import { createStore } from 'vuex'

export default createStore({
	state: {
		main_url: 'https://mobile-dev.expo-stat.ru',
		user: {
			name: '',
			id: null,
			aproved: false,
		},
		last_camera_id: null,
		state_exhib: {
			id: null,
			label: null
		},
		exhib_list: [

		],
		state_event: {
			id: null,
			label: null,
			start_ts: null,
			end_ts: null
		},

		// uuid_code - uuid отсканированного кода
		// uuid_code.code:		[String] - отсканированный код,
		// uuid_code.readed_ts:	[timestamp] - время прочтения,
		// uuid_code.sended:	[Boolean] - отправлен ли на сервер,
		// uuid_code.sended_ts:	[timestamp] - время отправки
		scaned_code_list: {},

		// Array - содержит QR-коды в виде объекта для отправки на сервер
		// {
		//	uuid_code:	[String] -  uuid отсканированного кода
		//	code:		[String] - отсканированный код,
		//	readed_ts:	[timestamp] - время прочтения
		// }
		orderForShipment: [],

		packForShipment: [],
		event_list: [],
		preload_code: [],
		server_mode: [
			{ mode: 0, label: 'Online режим' },
			{ mode: 1, label: 'Смешаный режим' },
			{ mode: 2, label: 'Offline режим' },
		],
		server_mode_select: 2,
		server: {
			status: true,
			status_ts: Date.now()
		},
		errorMessage: null,

		debugMode: false,
	},
	getters: {
		server_info(state) {
			return state.server
		},
		user_id(state) {
			return state.user.id
		},
		user_name(state) {
			return state.user.name
		},
		exhib_list(state) {
			return state.exhib_list
		},
		exhib_id(state) {
			return state.state_exhib.id
		},
		event_id(state) {
			return state.state_event.id
		},
		event_list(state) {
			return state.event_list
		},
		mainTitle(state) {
			return [state.state_exhib.label, state.state_event.label]
			// return `${state.state_exhib.label || ''} ${state.state_event.label ? ': ' + state.state_event.label : ''}`
		},

		get_scaned_code(state) {
			return state.scaned_code_list
		},
		order_for_shipment_length(state) {
			return state.orderForShipment.length
		},
		pack_for_shipment(state) {
			return state.packForShipment
		},
		debug(state) {
			return state.debugMode
		},
	},
	mutations: {
		switchDebugMode(state, mode) {
			state.debugMode = !!mode
		},
		update_server_info(state, data) {
			state.server.status = data.status
			state.server.status_ts = data.status_ts
		},
		setUserId(state, user_uuid) {
			const set_uuid = localStorage.getItem('user_uuid') || user_uuid
			const set_aproved = localStorage.getItem('user_aproved') || false
			localStorage.getItem('user_uuid') || localStorage.setItem('user_uuid', set_uuid)
			localStorage.getItem('user_aproved') || localStorage.setItem('user_aproved', set_aproved ? 1 : 0)
			state.user.id = set_uuid
			state.user.name = localStorage.getItem('user_name')
			state.user.aproved = !!parseInt(set_aproved, 10)
		},
		setUserAprove(state, aprove) {
			const digAprove = aprove ? 1 : 0
			localStorage.setItem('user_aproved', digAprove)
			state.user.aproved = aprove
		},
		setUserName(state, user_name) {
			localStorage.setItem('user_name', user_name)
			state.user.name = user_name
		},
		// аппарат разлогинен, но uuid сохранен
		// clearUserId(state) {
		// 	// localStorage.setItem('user_uuid', null)
		// 	// state.user.id = null
		// 	state.user.aproved = false
		// },
		setExhib(state, exhib) {
			localStorage.setItem('exhib_id', exhib.id)
			state.state_exhib.id = exhib.id
			state.state_exhib.label = exhib.label
		},
		setEvent(state, set_event) {
			state.state_event.id = set_event.id
			state.state_event.label = set_event.label
			state.state_event.start_ts = set_event.start_ts
			state.state_event.end_ts = set_event.end_ts
		},
		setExhibList(state, list) {
			state.exhib_list = []
			list.forEach(item => {
				state.exhib_list.push({ id: parseInt(item.id, 10), label: item.label })
			})
		},
		setEventList(state, list) {
			state.event_list = []
			list.forEach(item => {
				state.event_list.push({ id: parseInt(item.id, 10), label: item.label, start_ts: item.start_ts, end_ts: item.end_ts })
			})
		},
		setLastCameraId(state, camera_id) {
			state.last_camera_id = camera_id
		},
		addPreloadCode(state, code) {
			state.preload_code.push(code)
		},
		clearPreloadCode(state) {
			state.preload_code = []
		},
		setAcceptCode(state, code_index) {
			state.preload_code[code_index].accepted = true
		},
		setServerMode(state, mode) {
			state.server_mode_select = mode
		},

		// добавляет новый код
		// code_data.code - code,
		// code_data.session_id - store.getters.event_id,
		// code_data.readed_ts - Date.now(),
		// code_data.sended - false,
		// code_data.sended_ts - null
		addToScanedCodeList(state, code_data) {
			const [code_uuid, code] = code_data
			state.scaned_code_list[code_uuid] = code
		},
		// редактирует уже существующий новый код
		// code_data.code - code,
		// code_data.session_id - store.getters.event_id,
		// code_data.readed_ts - timestamp,
		// code_data.sended - boolean,
		// code_data.sended_ts - timestamp
		updateScanedCodeListItem(state, code_date) {
			const [code_uuid, code] = code_date
			if (!state.scaned_code_list[code_uuid]) state.scaned_code_list[code_uuid] = {}
			state.scaned_code_list[code_uuid].code = code.code || state.scaned_code_list[code_uuid].code
			state.scaned_code_list[code_uuid].readed_ts = code.readed_ts || state.scaned_code_list[code_uuid].readed_ts
			state.scaned_code_list[code_uuid].sended = code.sended || state.scaned_code_list[code_uuid].sended
			state.scaned_code_list[code_uuid].sended_ts = code.sended_ts || state.scaned_code_list[code_uuid].sended_ts

		},

		clearOrderForShipment(state) {
			state.orderForShipment = []
			localStorage.removeItem('orderForShipment')
		},
		clearPackForShipment(state) {
			state.packForShipment = []
			if (state.orderForShipment.length > 0) {
				localStorage.setItem('orderForShipment', JSON.stringify(state.orderForShipment))
			} else {
				localStorage.removeItem('orderForShipment')
			}
		},
		getPackOrderForShipment(state) {
			const order_lenght = state.orderForShipment.length
			while (state.orderForShipment.length > 0 && state.packForShipment.length < 10) {
				state.packForShipment.push(state.orderForShipment.shift())
			}
		},
		addOrderForShipment(state, code) {
			let includes_uuid = state.orderForShipment.find(item_code => item_code.code_uuid === code.code_uuid)
			if (!includes_uuid) {
				state.orderForShipment.push(code)
			}
			if (state.orderForShipment.length > 0) {
				localStorage.setItem('orderForShipment', JSON.stringify(state.orderForShipment))
			} else {
				localStorage.removeItem('orderForShipment')
			}
		},
	},
	actions: {
		uuidv4() {
			return new Promise((resolve, reject) => {
				resolve("10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
					(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
				))
			})
		},
		checkLocalCodeAction({ state, commit }, code) {
			return new Promise((resolve, reject) => {
				try {
					const code_index = state.preload_code.findIndex(itemCode => {
						return itemCode.code === code.toString()
					})
					if (code_index >= 0) {
						commit('setAcceptCode', code_index)
						resolve(true)
					} else {
						resolve(false)
					}
				} catch (err) {
					reject(err)
				}
			})
		},

		errorProcessing(state, err) {
			state.errorMessage = err
			// console.log(err)
		},

		// Имитация ответов сервера
		//update scancollector
		serverUnlogin({ commit }) {
			commit('setUserAprove', false)
			// commit('clearUserId')
		},
		setUserId({ commit }, user_id) {
			commit('setUserId', user_id)
		},

		// обработка ответа сервер на отправленый QR
		async prepareData({ commit, getters }, serverResponse) {
			commit('clearPackForShipment')
			commit('getPackOrderForShipment')
			// return getters.pack_for_shipment
		},

		QrProcessing({ dispatch, commit }, serverResponse) {
			// обработка ответа сервер на отправленый QR
		}
	},
	modules: {
	}
})
